module.exports = __webpack_public_path__ + "static/media/sky.8cdfb00b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/select-country-modal/sky.png
// module id = 1945
// module chunks = 0